<template>
  <slot />
</template>

<script>
import { inject } from 'vue'
import { createConfigurationsProvider } from '@/composables/useConfigurations'
import { createDepartmentTypesProvider } from '@/composables/useDepartmentTypes'
import { createOrgTreeProvider } from '@/composables/useOrgTree'
import { createUsersProvider } from '@/composables/useUsers'

export default {
  name: 'AppProvider',
  setup() {
    const api = inject('api')

    const configurationsProvider = createConfigurationsProvider(api)
    const departmentTypesProvider = createDepartmentTypesProvider(api)
    const orgTreeProvider = createOrgTreeProvider(api)
    const usersProvider = createUsersProvider(api)

    let prefetched = false

    const resetPrefetch = () => {
      prefetched = false
    }

    const resetSessionData = () => {
      usersProvider.reset()
      orgTreeProvider.invalidateTree()
      resetPrefetch()
    }

    const prefetchSharedData = async ({ force = false } = {}) => {
      if (force) {
        resetPrefetch()
      }
      if (prefetched) {
        return
      }
      prefetched = true
      try {
        await Promise.all([
          orgTreeProvider.ensureTree({ includeEmployees: true }),
          usersProvider.ensureRoles(),
          departmentTypesProvider.fetchDepartmentTypes(),
          configurationsProvider.fetchConfigurations(),
        ])
      } catch (err) {
        prefetched = false
        console.error('Prefetch failed:', err)
      }
    }

    return {
      ...configurationsProvider,
      ...departmentTypesProvider,
      ...orgTreeProvider,
      ...usersProvider,
      prefetchSharedData,
      resetPrefetch,
      resetSessionData,
    }
  },
}
</script>
